import { shopSchema, shopsSchema } from "./schema";
import { getEntity, getEntityIds, getEntities } from "./base";

const path = "/portal/api/shops";

const getShop = (clientConfig, entityId) => {
  return getEntity(clientConfig, entityId, path, shopSchema);
};

const getShopIds = (clientConfig, offerType, dataStatus) => {
  return getEntityIds(
    clientConfig,
    dataStatus,
    path,
    offerType,
    clientConfig.limits
  );
};

const getShops = (clientConfig, dataStatus) => {
  return getEntities(clientConfig, dataStatus, path, shopsSchema);
};

export { getShop, getShopIds, getShops };
